export default {
  devices: 'APS-R Cihazları',
  device: 'APS-R Cihaz',
  newDevice: 'Yeni Cihaz',
  addNewDevice: 'Yeni Cihaz Ekle',
  editDevice: 'Cihaz Düzenle',
  deviceInfo: 'Cihaz Bilgileri',
  searchDevices: 'Cihaz ara...',
  customerId: 'Müşteri ID',
  customerIdPlaceholder: 'ör. APS-001',
  customerIdHelp: 'Sensörden gelen benzersiz tanımlayıcı (customer_ID). MAC adresi girilirse zorunlu değildir.',
  customerIdRequired: 'Müşteri ID gereklidir',
  customerIdOrMacRequired: 'Müşteri ID ya da MAC adresi girin',
  macAddress: 'MAC Adresi',
  macAddressPlaceholder: 'ör. 00:0B:91:A4:09:BC',
  macAddressHelp:
    "Araç router'ının Clients listesinde görünür. Her biçim kabul edilir. Sensör ilk bağlandığında bu adresle eşleşir. Zaten veri gönderen bir sensörde değiştirilirse sensör yeni bir cihaz olarak kaydolur.",
  macAddressInvalid: 'MAC adresi 12 hex basamaktan oluşmalı, ör. 00:0B:91:A4:09:BC',
  firmwareVersion: 'Yazılım Versiyonu',
  ipAddress: 'IP Adresi',
  status: 'Durum',
  statusActive: 'Aktif',
  statusInactive: 'Pasif',
  statusMaintenance: 'Bakımda',
  lastSeen: 'Son Görülme',
  vehicleAssignment: 'Araç Ataması',
  noVehicle: '-- Araç Yok --',
  noVehicleAssigned: 'Bu cihaza araç atanmamış',
  currentOccupancy: 'Mevcut Doluluk',
  currentPassengers: 'Mevcut Yolcu',
  attendanceSoFar: 'Toplam Biniş',
  deviceCreated: 'Cihaz başarıyla oluşturuldu',
  deviceUpdated: 'Cihaz başarıyla güncellendi',
  deviceDeleted: 'Cihaz başarıyla silindi',
  deleteConfirmation: 'Bu cihazı silmek istediğinizden emin misiniz?',
};
